import styled from 'styled-components'

const AppSectionStyle = styled.div`
	--appSubtitleMarginTopAndBottom: var(--sp13x) 0 var(--sp6x) 0;
	--appSubtitleMaxWidth: var(--sp171x);
	--appDescriptionMaxWidth: var(--sp146x);
	--downloadLinkWrapMaxWidth: var(--sp79x);
	--videoMarginTop: var(--sp13x);

	margin-top: var(--sectionMargin);

    .animStartPos {
        transform: translateY(100%);
    }

	.appSubtitle {
		margin: var(--appSubtitleMarginTopAndBottom);
		max-width: var(--appSubtitleMaxWidth);
	}

	.appVideo {
		display: flex;
		margin: var(--videoMarginTop) auto 0;
		width: 70.5%;
		object-fit: cover;
		border-radius: var(--sp5x);
        overflow: hidden;
        
        .video-cont {
            position: relative;
            width: 100%;
            padding-top: 46.33%;

            video {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                transform: translate(-50%, -50%);
            }
        }
	}

	.descriptionWrap {
		justify-content: space-between;

		.downloadLinkWrap {
			max-width: var(--downloadLinkWrapMaxWidth);
			width: 100%;
            height: fit-content;

			.appStoreLink {
				width: 43.2%;
				.imageCont {
					padding-top: 41.1%;
					img {
						object-fit: contain;
					}
				}
			}

			.googlePlayLink {
				width: 49.4%;
				.imageCont {
					padding-top: 36.1%;
					img {
						object-fit: contain;
					}
				}
			}
		}

		.appDescription {
			max-width: var(--appDescriptionMaxWidth);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--appSubtitleMarginTopAndBottom: var(--sp10x) 0 var(--sp5x) 0;
		--appSubtitleMaxWidth: var(--sp108x);
		--appDescriptionMaxWidth: var(--sp110x);
		--downloadLinkWrapMaxWidth: var(--sp78x);
		--videoMarginTop: var(--sp10x);

		.descriptionWrap {
			.downloadLinkWrap {
				.appStoreLink {
					width: 43.3%;
					.imageCont {
						padding-top: 35.2%;
					}
				}

				.googlePlayLink {
					width: 50.3%;
					.imageCont {
						padding-top: 30.8%;
					}
				}
			}
		}

		.appVideo {
			width: 70.6%;
			height: var(--sp73x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--appSubtitleMarginTopAndBottom: var(--sp8x) 0 var(--sp4x) 0;
		--appSubtitleMaxWidth: var(--sp92x);
		--appDescriptionMaxWidth: var(--sp93x);
		--downloadLinkWrapMaxWidth: var(--sp62x);
		--videoMarginTop: var(--sp8x);

		.descriptionWrap {
			.downloadLinkWrap {
				.appStoreLink {
					width: 43.4%;
					.imageCont {
						padding-top: 37.2%;
					}
				}

				.googlePlayLink {
					width: 50%;
					.imageCont {
						padding-top: 32.2%;
					}
				}
			}
		}
		.appVideo {
			width: 69.8%;
			border-radius: var(--sp4x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.LaptopSize}) {
		--appSubtitleMarginTopAndBottom: var(--sp7x) 0 var(--sp3x) 0;
		--appSubtitleMaxWidth: var(--sp87x);
		--appDescriptionMaxWidth: var(--sp57x);
		--downloadLinkWrapMaxWidth: var(--sp55x);
		--videoMarginTop: var(--sp7x);

		.descriptionWrap {
			.downloadLinkWrap {
				.appStoreLink {
					width: 43.7%;
					.imageCont {
						padding-top: 37.5%;
					}
				}

				.googlePlayLink {
					width: 50.5%;
					.imageCont {
						padding-top: 32.5%;
					}
				}
			}
		}
		.appVideo {
			width: 74.2%;
			border-radius: var(--sp3x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--appSubtitleMarginTopAndBottom: var(--sp7x) 0 var(--sp3x) 0;
		--appSubtitleMaxWidth: 100%;
		--appDescriptionMaxWidth: 100%;
		--downloadLinkWrapMaxWidth: var(--sp55x);
		--videoMarginTop: var(--sp7x);

		.descriptionWrap {
			flex-direction: column;
			.downloadLinkWrap {
				margin-top: var(--sp7x);
				.appStoreLink {
					width: 43.7%;
					.imageCont {
						padding-top: 37.5%;
					}
				}

				.googlePlayLink {
					width: 50.3%;
					.imageCont {
						padding-top: 32.6%;
					}
				}
			}
		}
		.appVideo {
			width: 98.9%;
			border-radius: var(--sp3x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--appSubtitleMarginTopAndBottom: var(--sp5x) 0 var(--sp2x) 0;
		--appSubtitleMaxWidth: 100%;
		--appDescriptionMaxWidth: 100%;
		--downloadLinkWrapMaxWidth: var(--sp46x);
		--videoMarginTop: var(--sp5x);

		.descriptionWrap {
			flex-direction: column;
			.downloadLinkWrap {
				margin-top: var(--sp7x);
				.appStoreLink {
					width: 44.3%;
					.imageCont {
						padding-top: 36.3%;
					}
				}

				.googlePlayLink {
					width: 50.9%;
					.imageCont {
						padding-top: 31.5%;
					}
				}
			}
		}
		.appVideo {
			width: 100%;
			border-radius: var(--sp2x);
		}
	}
`

export default AppSectionStyle
